import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { chevronBackIcon, closeIcon, menuIcon } from '../icons';
import ImageButton from '../widgets/ImageButton';
import './Screen.css';
import { registerKeyHandler, unregisterKeyHandler } from './GlobalKeyHandler';
import Icon from '../widgets/Icon';
import FlowForm, { getKeyHandler } from './FlowForm';
/**
 * A screen is a layout structure consisting of a title and a body.
 */
const Screen = ({ title, children, className, onClose, closeButton, menuButton, onMenu, onProfile, avatarUrl, userName, topRightIcon, justifyTitle = 'left' }) => {
    useEffect(() => {
        if (!closeButton || !onClose)
            return;
        registerKeyHandler('screen ' + title, {
            'Escape': () => { onClose(); return true; },
        }, false, 0);
        return () => unregisterKeyHandler('screen ' + title);
    }, [title, closeButton]);
    const handleProfileKeyDown = getKeyHandler({
        enterBehaviour: 'action',
        spaceBehaviour: 'action',
        sidewaysBehaviour: 'left',
        onAction: () => onProfile === null || onProfile === void 0 ? void 0 : onProfile()
    });
    return _jsxs("section", { className: className !== null && className !== void 0 ? className : '', children: [_jsxs(FlowForm, { main: false, className: `screenHeader ${justifyTitle}`, children: [menuButton && _jsx(ImageButton, { className: menuButton, icon: menuIcon, size: 'large', onClick: onMenu, focussable: 'sideway', sidewaysBehaviour: 'both' }), closeButton && _jsx(ImageButton, { className: closeButton, icon: closeButton == 'back' ? chevronBackIcon : closeIcon, size: 'large', onClick: onClose, focussable: 'sideway', sidewaysBehaviour: 'both' }), _jsx("h2", { className: 'pageTitle', children: title }), onProfile && _jsxs("button", { className: 'userProfile flowFocussable sidewayFocus', onClick: onProfile, onKeyDown: handleProfileKeyDown, tabIndex: 0, children: [userName && _jsx("span", { className: 'userName', children: userName }), _jsx("img", { src: avatarUrl, alt: 'Profile', className: 'avatar' })] }), topRightIcon && _jsx(Icon, { icon: topRightIcon, size: 'large' })] }), _jsx("div", { className: 'screenBody', children: children })] });
};
export default Screen;
